//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'CustomSeparator',
  props: {
    text: {
      type: String,
      default: () => ''
    },
    cssVariables: {
      type: Object,
      default: () => ({// "--text-color": "#727272",
        // "--background-color": "#e2e2e2",
        // "--text-color-active": "#fff",
        // "--background-color-active": "#3f5b60",
        // "--line-separator-color": "#3f5b60",
        // "--line-separator-width": "1px",
      })
    },
    options: {
      type: Array,
      default: () => []
    },
    pillMode: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    listOptions: [],
    label: '',
    theme: {}
  }),
  watch: {
    /**
     * text
     * label para mostrar en el modo de borde
     */
    text: {
      handler() {
        this.label = String(this.text);
      },

      immediate: true
    },

    /**
     * cssVariables
     * Variables css a usar por el componente
     */
    cssVariables: {
      handler() {
        this.theme = { ...this.colors
        };
        this.changeTheme(this.theme);
      },

      immediate: true
    },

    /**
     * List of separators
     */
    options: {
      handler() {
        this.listOptions = [...this.options];
      },

      immediate: true
    }
  },

  mounted() {
    this.changeTheme();
  },

  methods: {
    isEmptyObject(obj) {
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    },

    changeTheme(theme) {
      const localTheme = theme || this.theme;

      if (!this.$el && this.isEmptyObject(localTheme)) {
        return;
      }

      const separatorElement = this.$el.querySelector('.separator-custom');
      const colors = { ...this.cssVariables
      };

      for (let variable in colors) {
        separatorElement.style.setProperty(variable, colors[variable]);
      }
    },

    changeOption(idx) {
      this.options.forEach(element => {
        element.active = false;
      });
      let selectedOption = this.options[idx];
      selectedOption.active = true;
      this.$emit('selected', selectedOption.id ? selectedOption.id : idx);
      this.$forceUpdate();
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "",
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm.label ? _c('div', {
    staticClass: "separator-custom"
  }, [_c('span', {
    staticClass: "separator-custom__text separator-custom__text--active"
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n      ")])]) : _c('div', {
    staticClass: "separator-custom separator-custom--flex-d-column",
    class: {
      'separator-custom--pill': _vm.pillMode
    }
  }, _vm._l(_vm.listOptions, function (option, idx) {
    var _obj;

    return _c('span', {
      key: option.name + "-" + idx + "-" + Math.random(),
      staticClass: "separator-custom__text separator-custom__text--fixed",
      class: (_obj = {}, _obj[option.class] = option.class, _obj.active = option.active, _obj['separator-custom__text separator-custom__text--pill'] = _vm.pillMode, _obj),
      attrs: {
        "data-id": "" + (option.id ? option.id : idx)
      },
      on: {
        "click": function ($event) {
          return _vm.changeOption(idx);
        }
      }
    }, [_vm._v("\n        " + _vm._s(option.name) + "\n      ")]);
  }), 0)])]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-28415682_0", {
    source: ".separator-custom[data-v-28415682]{--text-color:#727272;--background-color:#e2e2e2;--text-color-active:#fff;--background-color-active:#3f5b60;--line-separator-color:#3f5b60;--line-separator-width:1px;display:flex;align-items:center;text-align:center;font-weight:700;font-size:17px;line-height:23px;font-family:Lato,sans-serif}@media screen and (max-width:480px){.separator-custom--flex-d-column[data-v-28415682]{flex-direction:column}}.separator-custom__text[data-v-28415682]{cursor:pointer;color:var(--text-color);background:var(--background-color) 0 0 no-repeat padding-box;padding:5px 16px}.separator-custom__text[data-v-28415682]:first-child,.separator-custom__text[data-v-28415682]:last-child{border-radius:21px}.separator-custom__text--pill[data-v-28415682]:first-child,.separator-custom__text--pill[data-v-28415682]:last-child{border-radius:0}.separator-custom__text--pill[data-v-28415682]:last-child{border-top-right-radius:21px;border-bottom-right-radius:21px}.separator-custom__text--pill[data-v-28415682]:first-child{border-top-left-radius:21px;border-bottom-left-radius:21px}.separator-custom__text--active[data-v-28415682],.separator-custom__text.active[data-v-28415682]{color:var(--text-color-active);background-color:var(--background-color-active)}@media screen and (max-width:480px){.separator-custom__text--fixed[data-v-28415682],.separator-custom__text.fixed[data-v-28415682]{width:100%;margin-bottom:2%}}.separator-custom[data-v-28415682]::after,.separator-custom[data-v-28415682]::before{content:\"\";flex:1;border-bottom:var(--line-separator-width) solid var(--line-separator-color);margin-right:15px;margin-left:15px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-28415682";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

const install = function installCustomSeparator(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('CustomSeparator', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
